import router from './index'

export const getRoute = () => {
  return {
    ...router.currentRoute.value,
    from: router.options.history.state.back
  }
}